/**
 * API Configuration
 * 
 * In development: Uses Vite proxy (relative /api paths)
 * In production: Uses VITE_API_BASE_URL env variable
 */

// Get the API base URL from env or use default
const getApiBaseUrl = (): string => {
  // @ts-ignore - injected by Vite define
  if (typeof __API_BASE_URL__ !== 'undefined') {
    // @ts-ignore
    return __API_BASE_URL__
  }
  
  // Fallback for development
  return import.meta.env.VITE_API_BASE_URL || '/api'
}

export const API_BASE_URL = getApiBaseUrl()

/**
 * Helper to build full API URL
 */
export function apiUrl(path: string): string {
  const base = API_BASE_URL.replace(/\/$/, '')
  const cleanPath = path.replace(/^\//, '')
  return `${base}/${cleanPath}`
}
